<template>
  <div>
    <!-- 设置应用名称 -->
    <div  class="createAn7-html">
      <div v-if="step === 1" class="createAn7-box intro-x">
        <div class="createAn7-item">
          <div class="appName">应用主名称</div>
          <div class="elInput">
            <el-input v-model="hostName" placeholder="输入应用主名称"></el-input>
          </div>
        </div>
      </div>
      <CreateAn8 v-if="step === 2" :loading8="isLoadding" :appData="{}"></CreateAn8>
    </div>

    <div class="createrAn-Buttom-box" style="justify-content: center;">
      <div v-if="step === 1" class="createrAn-Buttom intro-x">
        <span class="span9 span1" @click="awaitSet()">稍后设置</span>
        <span class="span9 span2" @click="handleSetAppName()">下一步</span>
      </div>

      <div v-if="step === 2" class="createrAn-Buttom intro-x">
          <span class="span9 span2" @click="handleGoApp">
            前往我的应用页面
          </span>
      </div>

    </div>
  </div>
</template>

<script>
import CreateAn8 from '@/modules/createAn8'
import { editBySupplyChain } from '@/api/supply-chain/supply-chain'
import Cookies from "js-cookie";

export default {
  components: { CreateAn8 },
  props: {
    uuid: {
      type: String,
      default: () => undefined
    }
  },
  data() {
    return {
      imageUrl: null,
      hostName: '',
      isLoadding: true,
      step: 1
    }
  },
  computed: {
    userInfo: function () {
      return JSON.parse(Cookies.get("userInfo"));
    }
  },
  mounted() {
    this.step = 1
  },
  methods: {

    // 前往我的应用
    handleGoApp() {
      this.$router.push("/Dashboard/supplyChainApp");
    },
    // 稍后设置
    awaitSet() {
      this.step = 2
      setTimeout(() => {
        this.isLoadding = false
      }, 1000)
    },
    // 设置应用名
    handleSetAppName() {
      if (this.hostName === undefined || this.hostName.length === 0) {
        this.$message.error('请设置应用名～')
        return
      }
      this._editBySupplyChain()
    },
    _editBySupplyChain() {
      const params = {}
      params.uuid = this.uuid
      params.info = {
        main: {
          name: this.hostName
        }
      }
      editBySupplyChain(params).then(resp => {
        if (resp.code === 0) {
          this.step = 2
          setTimeout(() => {
            this.isLoadding = false
          }, 1000)
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.createAn7-html {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}

.createAn7-box {
  display: inline-block;
  margin-right: 20px;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
  .createAn7-item {
    width: 194px;

    background: #ffffff;
    border: 1px solid #eef2f7;
    border-radius: 22px;
    margin-bottom: 20px;
    padding: 10px;
  }
  .createAn7-name {
    font-size: 14px;
    color: #333333;
  }

  .elInput {
    width: 100%;
  }
}


.logoClass {
  text-align: left;
  padding-left: 5px;
}
.appName {
  text-align: left;
  margin-bottom: 7px;
  padding-left: 5px;
}

.avatar-uploader-box {
  overflow: hidden;
  .avatar-uploader {
    width: 110px;
    height: 110px;
    background: #eef2f7;
    float: left;
    border-radius: 12px;
    text-align: center;
    line-height: 110px;
    font-size: 10px;
    margin: 12px 0 8px;
  }
}

@media screen and (max-width:600px) {

  .createAn7-box {
    width: 100% !important;
    padding: 0 20px !important;
    box-sizing: border-box !important;
    .createAn7-item {
      width: 100% !important;
      margin-bottom: 0 !important;
    }
  }


}

.createTitle {
  margin: 41px 0 15px;
  color: #2d3748;
  font-size: 18px;
  display: block;
}

.createHtml-box {
  overflow: hidden;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
}

.createHtml {
  border-bottom: 1px solid #f5f5f5;
}

.createBody {
  width: 100%;
  background: #ffffff;
  border-radius: 22px;
}

.steps-box {
  padding: 40px 100px;
}

.createrAn-Buttom-box {
  widows: 100%;
  display: flex;
  width: 77.6%;
  padding: 40px 0 80px;
  margin: 0 auto;
  justify-content: space-between;
}

.createrAn-Buttom {
  .span0 {
    display: inline-block;
    width: 96px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }
  .span9 {
    display: inline-block;
    width: 208px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }

  .span1 {
    color: #788598;
    background: #edf1f6;
  }
  .span1:active {
    background: #f8f8f8;
  }

  .span2 {
    color: rgb(235, 233, 233);
    background: #1890ff;
    margin-left: 20px;
  }
  .span2:active {
    background: #2d97fa;
  }
}

.loading8Clss {
  background: #e2f0ff !important;
  cursor: no-drop !important;
  color: #ffffff !important;
}

.button {
  width: 236px;
  height: 37px;
  background: #1890ff;
  border-radius: 12px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
  color: #fff;
}

.button:active {
  background: #399fff;
}

@media screen and (max-width: 600px) {
  .createHtml {
    display: none !important;
  }

  .createrAn-Buttom {
    display: flex !important;
    padding: 20px !important;
    justify-content: center;
    align-items: center;
    .span2 {
      margin-left: 20px !important;
    }
  }
}


</style>
